import { FC, useMemo, useCallback } from 'react'
import styles from 'components/features/socialFeed/ComposeImages/ComposeImages.styl'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { createComposeImagesSelector } from 'selectors/feedComposeSelectors'
import { ComposeId } from 'interfaces/feed'
import { shallowEqual } from 'react-redux'
import { UserImage, UserImageId } from 'interfaces/userImage'
import { ComposeImage } from 'components/features/socialFeed/ComposeImage/ComposeImage'
import { feedComposeImageRemoveActionCreator } from 'actions/feedComposeActions'

type ComposeImagesAction = {
  composeId: ComposeId
}

export const ComposeImages: FC<ComposeImagesAction> = (props) => {
  const {
    composeId,
  } = props
  const composeImagesSelector = useMemo(createComposeImagesSelector, [])
  const images = useStoreSelector<UserImage[]>((store) => composeImagesSelector(store, props), shallowEqual)

  const dispatch = useStoreDispatch()
  const handleRemove = useCallback<(id: UserImageId) => void>((id) => {
    dispatch(feedComposeImageRemoveActionCreator.request({ id, composeId }))
  }, [composeId, dispatch])

  const imagesChild = useMemo(() => (images.map((image) => (
    <div
      key={ image.id }
      className={ styles.image }
    >
      <ComposeImage
        userImage={ image }
        onRemove={ () => handleRemove(image.id) }
      />
    </div>
  ))), [handleRemove, images])

  if (!imagesChild.length) {
    return null
  }

  return (
    <div className={ styles.images }>
      { imagesChild }
    </div>
  )
}
